/**
 * 운영정책 페이지 (호주 법률 준수)
 */

import Seo from "@/components/seo/Seo";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle, FileText, Shield } from "lucide-react";
import { Link } from "wouter";

export default function Policy() {
  return (
    <>
      <Seo
        title="운영정책 — OZK News"
        description="OZK News 운영정책 및 커뮤니티 가이드라인"
        path="/policy"
      />

      <div className="min-h-screen bg-background">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">운영정책</h1>
            <p className="text-lg text-muted-foreground">
              OZK News 커뮤니티 운영 가이드라인
            </p>
          </div>

          <Alert className="mb-6">
            <Shield className="h-4 w-4" />
            <AlertDescription>
              본 운영정책은 호주 연방법(Australian Consumer Law, Competition and
              Consumer Act 2010)을 준수합니다.
            </AlertDescription>
          </Alert>

          <div className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <FileText className="w-5 h-5" />
                  게시글 작성 규칙
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div>
                  <h3 className="font-semibold mb-2">금지 사항</h3>
                  <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                    <li>허위 정보, 사기성 내용 게시</li>
                    <li>타인의 개인정보 무단 공개</li>
                    <li>혐오 발언, 차별적 표현</li>
                    <li>저작권 침해 콘텐츠</li>
                    <li>스팸, 광고성 게시물 반복 게시</li>
                    <li>불법 상품 또는 서비스 판매</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">권장 사항</h3>
                  <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                    <li>정확하고 유용한 정보 제공</li>
                    <li>다른 사용자에 대한 존중</li>
                    <li>명확한 제목과 내용 작성</li>
                    <li>적절한 카테고리 선택</li>
                  </ul>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <AlertTriangle className="w-5 h-5" />
                  신고 및 제재
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-muted-foreground">
                  운영정책 위반 시 경고, 게시글 삭제, 계정 일시 정지 또는 영구
                  정지 등의 조치가 취해질 수 있습니다.
                </p>
                <p className="text-muted-foreground">
                  신고는{" "}
                  <Link href="/support">
                    <span className="text-brand-primary hover:underline">
                      고객센터
                    </span>
                  </Link>
                  를 통해 접수하실 수 있습니다.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>중고거래 안전 수칙</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                  <li>거래 전 상대방 신원 확인</li>
                  <li>직거래 시 안전한 공공장소에서 만나기</li>
                  <li>상품 상태를 사진으로 확인하기</li>
                  <li>계약서 작성 및 증빙 자료 보관</li>
                  <li>의심스러운 거래는 신고하기</li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
